export const VERSION_NAME = 'feature/DEV-00796';
export const VERSION_HASH = '3c6e1ee068e0119de5ebd39d974029f91a4c4ef2';
